import Badge, { BadgeProps } from "@mui/material/Badge";
import { MissionStatus } from "@/lib/models/mission";
import { MissionResultMap } from "@/lib/mission";

const App = ({
  children,
  status,
  ...props
}: {
  children: any;
  status: MissionStatus;
  item?: any;
} & Omit<BadgeProps, 'children' | 'badgeContent' | 'color' | 'anchorOrigin'>) => {
  const statusMap = MissionResultMap[status];
  return (
    <Badge
      badgeContent={statusMap.content}
      color={statusMap.badgeColor}
      anchorOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
      sx={{ 
        zIndex: 10000,
        position: 'relative',
        '& .MuiBadge-badge': {
          zIndex: 10000,
          position: 'absolute',
        },
        ...props.sx
      }}
      {...props}
    >
      {children}
    </Badge>
  );
};

export default App;
